<template>
  <div :class="$style.logo">
    <svgLogo
      v-if="isTabletLandscapeUp"
      width="178"
    />
    <svgLogoRound
      v-else
      width="30"
    />
  </div>
</template>

<style lang="scss" module>
.logo {
  height: 40px;
  display: flex;
  align-items: center;

  text-align: center;
  position: relative;
  margin-left: 15px;

  @include for-tablet-landscape-up {
    width: 178px;
    height: 60px;
  }
}
</style>

<script>
import { mapGetters } from 'vuex';
import svgLogo from '@/images/icons/logo-white.svg?inline';
import svgLogoRound from '@/images/icons/logo-white-round.svg?inline';

export default {
  name: 'Logo',

  components: {
    svgLogo,
    svgLogoRound,
  },

  computed: {
    ...mapGetters('ui', [
      'isTabletLandscapeUp',
    ]),
  },
};
</script>
